// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"ba4c78feed8e8de65939","263":"47bac3586a0622bf8637","791":"cc3e11ecbc273b5fb7d9"}[chunkId] + ".js";
};